import { Component, OnInit,ViewChild,TemplateRef,ElementRef,Input, group } from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { GroupService } from '../../service/group.service';
import { HttpErrorResponse } from '@angular/common/http';
import {Globals} from '../.././globals';
import { commonService } from '../../service/common.service';

@Component({
  selector: 'app-group-right-sidebar',
  templateUrl: './group-right-sidebar.component.html',
  styleUrls: ['./group-right-sidebar.component.css'],
  providers:[GroupService]
})

export class GroupRightSidebarComponent implements OnInit {

  @Input() public groupId;
  

  sugesstedGroup:any;
  groupProfileUrl  = this.global.groupProfileUrl;
  userData:any;
  constructor(private commonService:commonService,private global:Globals,private _group:GroupService,private modalService: NgbModal,private router:Router,private route:ActivatedRoute) { }


  ngOnInit() {
    this.commonService.profile.subscribe((data:any)=>{
       if(data){
       this.userData=data; 
       this.getgroupmemberdetails();
       }else{
         this.userData={};
         this.getgroupmemberdetails();
       } 
     });

   
  }


  getgroupmemberdetails(){

    this._group.sugesstedGroup({"group":this.groupId,'userId':this.userData.id}).subscribe((data:any)=>{
      if(data.error==0){ 
        this.sugesstedGroup = data.results;
       // console.log(">>>>>>>>>>>>>>>>>>>>>")
       // console.log(this.sugesstedGroup);
    }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        //this.msg = data.message;
       // this.isError = true;
       // this.isSuccess = false;
        }
      }
  },
      (error : HttpErrorResponse)=>{
  
      });

  }

  groupsdetails(id){
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 
    this.router.navigate(['/groups/'+encodeURIComponent(btoa(id))])
  }

  requesttojoin(event,index){  
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 

  this._group.requestoJoin({"group":encodeURIComponent(btoa(event.id)),'status':"REQUEST_JOIN",'userId':this.userData.id}).subscribe((data:any)=>{
       if(data.error==0){ 
         this.sugesstedGroup.splice(index, 1);
       }else{
         if(data.message=="Failed to authenticate token."){
           this.router.navigate(['/']);
         }else{
         //this.msg = data.message;
        // this.isError = true;
        // this.isSuccess = false;
         }
       }
   },
       (error : HttpErrorResponse)=>{
       //  this.isError = true;
         //this.msg="internal server error!";
       });

   }
   
   needLogin(){
    this.commonService.setLoginBox(true);        
  }

  getGroupImagePath(path,width,height){
    if(!path){
      path='default.png';
    }
 

 if(width!=undefined && height!=undefined){
  //let res=this.global.websiteImgUrl+this.global.groupProfileFolder+'/'+path+'&width='+width+'&height='+height;
  let res=this.global.objectStorage+this.global.groupProfileFolder+'/'+path;
  return res;
}else{
  //let res=this.global.websiteImgUrl+this.global.profileFolder+'/'+path;
  let res=this.global.objectStorage+this.global.profileFolder+'/'+path;
  return res;
}

  }
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/group-right-sidebar/group-right-sidebar.component.ts